export default {
    title: 'Mobile phone',
    verificationDescription: 'In order to provide you with the best service, it is necessary to verify mobile number of a Montenegrin network.',
    back: 'Back',
    phoneInput : {
        label: 'Phone number',
        placeholder: '067/067-067'
    },
    button : {
        sendCode: {
            'title' : 'Send code',
            'infoAlert' : 'After clicking the Submit code button, you will receive the code which you will enter on next page. You can skip this step and verify your phone number later.'
        },
        confirmCode: {
            'title' : 'Confirm',
            'infoAlert' : 'You can set your notification preferences in your profile settings.'
        },
        skip: 'Skip'
    },
    enterRecievedCode: 'Enter the code we sent to:',
    codeInput: {
        label: 'Code',
        placeholder: '****'
    },
    resend: 'Resend',
    swal: {
        areYourSure: 'Are you sure?',
        weWillSendCodeTo: 'We will send code to:',
        yes: 'Yes',
        no: 'No',
        whyDidThisHappen: 'Why did this happen?'
    }
};
